/**
 * Custom Plotly.js bundle that only registers the trace types actually used by
 * this application.  This drops the bundled Plotly size from ~10 MiB (full dist)
 * to roughly ~3 MiB.
 *
 * If you hit a "No registered module of type ..." error, add the missing trace
 * module here.
 */

var Plotly = require('plotly.js/lib/core');

// Cartesian traces actually used in the app
Plotly.register([
  require('plotly.js/lib/scatter'),
  require('plotly.js/lib/scattergl'),
  require('plotly.js/lib/bar'),
  require('plotly.js/lib/box'),
  require('plotly.js/lib/violin'),
  require('plotly.js/lib/heatmap'),
  require('plotly.js/lib/histogram'),
  require('plotly.js/lib/histogram2d'),
  require('plotly.js/lib/histogram2dcontour'),
  require('plotly.js/lib/contour'),
  require('plotly.js/lib/pie'),
  require('plotly.js/lib/waterfall'),
  require('plotly.js/lib/funnel'),
]);

module.exports = Plotly;
